import * as Sentry from "@sentry/react";
import { CaptureConsole } from "@sentry/integrations";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initAnalytics } from "./helpers/analytics";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    new Sentry.Replay(),
    new CaptureConsole({
      levels: ["error"],
    }),
  ],
  ignoreErrors: [
    // Network failures — user's connection, not actionable
    "TypeError: Load failed",
    "TypeError: Failed to fetch",
    "TypeError: NetworkError",
    "TypeError: cancelled",
    // Firebase network/offline issues
    "Could not reach Cloud Firestore backend",
    "Connection failed 1 times",
    "Failed to get document because the client is offline",
    "auth/internal-error",
    // IndexedDB — browser-level issue
    "Connection to Indexed Database server lost",
    // Browser extensions injecting into the page
    "Object Not Found Matching Id",
    "runtime.sendMessage",
    // lightgallery plugin bugs (third-party)
    /lg-zoom/,
    /lg-video/,
    // Video/media playback — harmless browser quirks
    "The play() request was interrupted",
    "The operation is insecure",
    // Firebase Storage — network or missing assets
    "storage/retry-limit-exceeded",
    "storage/unauthorized",
    // Device/permission errors — user's device, not actionable
    "Couldn't get selected device",
    // React DOM manipulation errors from browser extensions (Grammarly, ad blockers)
    "insertBefore",
    // AbortError — generic cancelled requests
    "AbortError",
    // EXIF/image parsing errors in third-party libs
    "Offset is outside the bounds of the DataView",
    "PreviewImage not found",
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // (capture 100% of the transactions in dev), 10% in production
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
